import { __decorate, __param } from 'tslib';
import { ComponentFactoryResolver, Inject, Injector, ElementRef, Optional, Input, Directive, forwardRef, NgModule } from '@angular/core';
import { TuiPortalService, TuiActiveZoneDirective, TuiParentsScrollService } from '@taiga-ui/cdk';
import { AbstractTuiDropdown } from '@taiga-ui/core/abstract';
import { TUI_DROPDOWN_DIRECTIVE } from '@taiga-ui/core/tokens';
import { TuiDropdownBoxModule } from '@taiga-ui/core/components/dropdown-box';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/cdk';
var TuiDropdownDirective_1;
let TuiDropdownDirective = TuiDropdownDirective_1 = class TuiDropdownDirective extends AbstractTuiDropdown {
    constructor(componentFactoryResolver, injector, portalService, elementRef, activeZone, refresh$) {
        super(componentFactoryResolver, injector, portalService, elementRef, activeZone);
        this.refresh$ = refresh$;
    }
    set open(value) {
        this.toggleDropdown(value);
    }
};
TuiDropdownDirective.ɵfac = function TuiDropdownDirective_Factory(t) { return new (t || TuiDropdownDirective)(ɵngcc0.ɵɵdirectiveInject(ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(Injector), ɵngcc0.ɵɵdirectiveInject(TuiPortalService), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TuiActiveZoneDirective, 8), ɵngcc0.ɵɵdirectiveInject(TuiParentsScrollService)); };
TuiDropdownDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiDropdownDirective, selectors: [["", "tuiDropdown", "", 5, "ng-container"]], inputs: { open: ["tuiDropdown", "open"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_DROPDOWN_DIRECTIVE,
                useExisting: forwardRef(() => TuiDropdownDirective_1)
            },
            TuiParentsScrollService,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
TuiDropdownDirective.ctorParameters = () => [
    { type: ComponentFactoryResolver, decorators: [{ type: Inject, args: [ComponentFactoryResolver,] }] },
    { type: Injector, decorators: [{ type: Inject, args: [Injector,] }] },
    { type: TuiPortalService, decorators: [{ type: Inject, args: [TuiPortalService,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: TuiActiveZoneDirective, decorators: [{ type: Inject, args: [TuiActiveZoneDirective,] }, { type: Optional }] },
    { type: TuiParentsScrollService, decorators: [{ type: Inject, args: [TuiParentsScrollService,] }] }
];
__decorate([
    Input('tuiDropdown')
], TuiDropdownDirective.prototype, "open", null);
TuiDropdownDirective = TuiDropdownDirective_1 = __decorate([ __param(0, Inject(ComponentFactoryResolver)),
    __param(1, Inject(Injector)),
    __param(2, Inject(TuiPortalService)),
    __param(3, Inject(ElementRef)),
    __param(4, Inject(TuiActiveZoneDirective)),
    __param(4, Optional()),
    __param(5, Inject(TuiParentsScrollService))
], TuiDropdownDirective);

let TuiDropdownModule = class TuiDropdownModule {
};
TuiDropdownModule.ɵfac = function TuiDropdownModule_Factory(t) { return new (t || TuiDropdownModule)(); };
TuiDropdownModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiDropdownModule });
TuiDropdownModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[TuiDropdownBoxModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDropdownDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiDropdown]:not(ng-container)',
                providers: [
                    {
                        provide: TUI_DROPDOWN_DIRECTIVE,
                        useExisting: forwardRef(() => TuiDropdownDirective_1)
                    },
                    TuiParentsScrollService,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver, decorators: [{
                type: Inject,
                args: [ComponentFactoryResolver]
            }] }, { type: ɵngcc0.Injector, decorators: [{
                type: Inject,
                args: [Injector]
            }] }, { type: ɵngcc1.TuiPortalService, decorators: [{
                type: Inject,
                args: [TuiPortalService]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc1.TuiActiveZoneDirective, decorators: [{
                type: Inject,
                args: [TuiActiveZoneDirective]
            }, {
                type: Optional
            }] }, { type: ɵngcc1.TuiParentsScrollService, decorators: [{
                type: Inject,
                args: [TuiParentsScrollService]
            }] }]; }, { open: [{
            type: Input,
            args: ['tuiDropdown']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDropdownModule, [{
        type: NgModule,
        args: [{
                imports: [TuiDropdownBoxModule],
                declarations: [TuiDropdownDirective],
                exports: [TuiDropdownDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiDropdownModule, { declarations: function () { return [TuiDropdownDirective]; }, imports: function () { return [TuiDropdownBoxModule]; }, exports: function () { return [TuiDropdownDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiDropdownDirective, TuiDropdownModule };

